import React, { useState } from "react";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { Tooltip } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";

/**
 * Slim notifications bell — mirrors buyer's ChatDropdown visually.
 * Wires up the dropdown shell; the actual list will be plugged in once
 * the shell has a notifications endpoint.
 */
const Notifications: React.FC = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((v) => !v);

  return (
    <Dropdown isOpen={open} toggle={toggle}>
      <DropdownToggle tag="div" style={{ display: "inline-block" }}>
        <Tooltip title="Notifications" placement="bottom">
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={(ev) => {
              ev.preventDefault();
              toggle();
            }}
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 40,
              height: 40,
              borderRadius: 12,
              background: open
                ? "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)"
                : "#f1f5f9",
              boxShadow: open
                ? "0 4px 12px rgba(37, 99, 235, 0.3)"
                : "0 2px 4px rgba(0,0,0,0.05)",
            }}
          >
            <BellOutlined
              style={{
                fontSize: 20,
                color: open ? "#fff" : "#475569",
              }}
            />
          </motion.div>
        </Tooltip>
      </DropdownToggle>
      <DropdownMenu end className="dropdown-menu-xl">
        <div className="dropdown-head">
          <span className="sub-title nk-dropdown-title">Notifications</span>
        </div>
        <div className="dropdown-body">
          <div className="text-center p-3">No notifications available.</div>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default Notifications;
